import type { OperatingWindow } from '../types';

// Aceita "HH:mm" direto OU ISO datetime ("2026-05-10T14:30:00") e retorna "HH:mm".
function extractTime(input: string | null | undefined): string | null {
  if (!input) return null;
  if (/^\d{2}:\d{2}$/.test(input)) return input;
  const m = input.match(/T(\d{2}:\d{2})/);
  return m ? m[1] : null;
}

// Comparação string-safe enquanto ambos forem zero-padded "HH:mm".
function compare(a: string, b: string): number {
  return a.localeCompare(b);
}

export interface ContinuousValidation {
  valid: boolean;
  error: string | null;
}

/**
 * Valida horário contra a janela operacional Continuous.
 *
 * Semântica: time ∈ [startTime, endTime) — fim é exclusivo, espelhando exatamente
 * a regra do backend (AvailabilityQueryService.ResolveAsync). Manter as duas
 * pontas idênticas evita "passa no front, falha no back" (e vice-versa).
 *
 * Retorna { valid: true, error: null } se a janela estiver ausente (ex: data
 * fechada) — quem chama decide se isso bloqueia ou não. Para validar o estado
 * do botão "Continuar" use `valid && operatingWindow != null` no caller.
 */
export function validateContinuousTime(
  value: string | null | undefined,
  window: OperatingWindow | null,
): ContinuousValidation {
  if (!window) return { valid: true, error: null };

  const time = extractTime(value);
  if (!time) {
    return {
      valid: false,
      error: `Escolha um horário entre ${window.startTime} e ${window.endTime}.`,
    };
  }

  const inRange = compare(time, window.startTime) >= 0 && compare(time, window.endTime) < 0;
  if (!inRange) {
    return {
      valid: false,
      error: `Horário fora do intervalo permitido. Escolha entre ${window.startTime} e ${window.endTime}.`,
    };
  }

  return { valid: true, error: null };
}
